export enum ShowingFilters {
  ALL = 'All',
  CONFIRMED = 'Confirmed',
  PENDING = 'Pending',
  COMPLETED = 'Completed',
  CANCELED = 'Canceled',
  DECLINED = 'Declined',
  EXPIRED = 'Expired',
}
